export const itemTypeColor: any = {
  MATERIAL: { color: "rgb(62,125,209)", bgcolor: "#EAF5FE", nm: "원자재" },
  PRODUCT: { color: "rgb(93,176,89)", bgcolor: "rgb(238,250,239)", nm: "제품" },
  SUBSIDIARY: { color: "rgb(233,167,57)", bgcolor: "rgb(254,249,222)", nm: "부자재" },
  SEMI_PRODUCT: { color: "rgb(230,112,46)", bgcolor: "rgb(253,244,231)", nm: "반제품" },
} as const;
